import React, { useEffect } from 'react';

import { LayoutBleed } from '../../layout/LayoutBleed/LayoutBleed';
import { Layout } from '../../layout/Layout/Layout';
import { Button } from '../Button/Button';

export const Footer = ({ cookieProId }: { cookieProId?: string }) => {
  useEffect(() => {
    if (!cookieProId) return;

    const script1 = document.createElement('script');
    script1.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script1.type = 'text/javascript';
    script1.dataset.domainScript = cookieProId;
    document.head.append(script1);

    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.innerHTML = 'function OptanonWrapper() {}';
    document.head.append(script2);

    return () => {
      if (script1.parentNode) {
        script1.remove();
      }
      if (script2.parentNode) {
        script2.remove();
      }
    };
  }, [cookieProId]);

  return (
    <div id="Footer" data-test="FOOTER">
      <LayoutBleed>
        <Layout position="middle center" horizontalGutter="16px">
          <span data-test="COPYRIGHT_TEXT">
            &copy; {new Date().getFullYear()} Axiom Law
          </span>
          <span>
            <a
              data-test="PRIVACY_NOTICE_LINK"
              href="https://www.axiomlaw.com/privacy-notice"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Notice
            </a>
          </span>
          <span>
            <a
              data-test="TERMS_OF_USE_LINK"
              href="https://www.axiomlaw.com/axiom-terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>
          </span>
          {cookieProId ? (
            <Button
              name="COOKIE_SETTINGS_BUTTON"
              pattern="secondary"
              variation="minimal"
              className="ot-sdk-show-settings"
            >
              Cookie Settings
            </Button>
          ) : null}
        </Layout>
      </LayoutBleed>
    </div>
  );
};
